/**
 * Audio publish's contracts (docs/contexts/audio-publish). The root holds
 * what every surface reads, the deterministic media URLs and the
 * private-revision rule, with no dependency: `@libs/utils` re-exports it for
 * the clients (the app, the admin console), whose bundlers read no subpath.
 *
 * Server-side subpaths: `./on-demand-audio` (a song's on-demand paths under a
 * runtime's media prefix), `./ports` (the publish-intents port it offers)
 * and `./events` (its Inngest event definitions).
 */
export * from "./mediaUrls";
export * from "./privateAudioRevision";
